import React from "react";
import {
  Tile,
  SkeletonText,
  SkeletonPlaceholder,
} from "carbon-components-react";
function LessonPodItemSkeleton(props) {
  return (
    <Tile className="lesson-card">
      <SkeletonText className="lesson-title"></SkeletonText>
      <SkeletonText className="lesson-due-date"></SkeletonText>
      <SkeletonPlaceholder className="lesson-thumbnail-container"></SkeletonPlaceholder>
    </Tile>
  );
}

export default LessonPodItemSkeleton;
